import React, { useState } from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import './LandingPage.css';
import discovery from '../seo/content.json';

export const LandingPage = ({ onStart, user, onSignInClick }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleStartClick = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      await onStart();
    } catch (error) {
      console.error("Start failed", error);
      setIsLoading(false);
    }
  };

  return (
    <div className="landing-page base-background">
      <Navbar currentUser={user} onSignInClick={onSignInClick} />

      <div className="scroll-container">
        <div className="hero-section">
          <div className="hero-content">

          {/* Ambient Background */}
          <div className="ambient-bg">
            <div className="ambient-orb orb-purple"></div>
            <div className="ambient-orb orb-pink"></div>
          </div>

          {/* Overline Badge */}
          <div className="hero-overline hero-stagger stagger-0">
            <span className="overline-sparkle">✨</span>
            <span className="overline-text">Your AI Life Coach</span>
          </div>

          {/* Main Headline */}
          <h1 className="headline hero-stagger stagger-1">
            You don't know
            <span className="headline-accent"> you.</span>
          </h1>
          <p className="subheadline hero-stagger stagger-2">
            Unlocked by a single pen stroke. Shared with friends. Guided by AI.
          </p>

          {/* Preview Card */}
          <div className="preview-card-container hero-stagger stagger-3">
            <div className="preview-card">
              <div className="preview-card-header">
                <div className="preview-avatar">?</div>
                <div className="preview-header-text">
                  <span className="preview-name">Your Name</span>
                  <span className="preview-type">YOUR ARCHETYPE</span>
                </div>
              </div>
              <div className="preview-quote">"A rare mix of deep empathy and laser-sharp logic."</div>
              <div className="preview-brain-split">
                <div className="preview-split-left">
                  <span className="preview-pct">76%</span>
                  <span className="preview-split-label">LOGICAL</span>
                </div>
                <span className="preview-split-icon">⚡</span>
                <div className="preview-split-right">
                  <span className="preview-pct">24%</span>
                  <span className="preview-split-label">INTUITIVE</span>
                </div>
              </div>
              <div className="preview-bar">
                <div className="preview-bar-fill" style={{ width: '76%' }}></div>
              </div>
              <div className="preview-strengths">
                <span className="preview-strength-pill">🤖 AI Engineering</span>
                <span className="preview-strength-pill">🚀 Startup Founder</span>
              </div>
              <div className="preview-career blurred-text insight-box">
                <span className="preview-career-label">💡 AI COACH INSIGHT</span>
                <span className="preview-career-value insight-text">
                  Ready to lead a technical team. Stop over-analyzing the risks.
                </span>
              </div>
              <div className="preview-frosted-overlay">
                <span className="preview-unlock-text">Curious? Uncover yours</span>
              </div>
            </div>
          </div>

          {/* CTA Button — inline for desktop */}
          <div className="cta-wrapper desktop-only hero-stagger stagger-4">
            <div className="cta-glow"></div>
            <button
              className={`glass-cta ${isLoading ? 'loading' : ''}`}
              onClick={handleStartClick}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <div className="button-spinner"></div>
                  <span className="cta-text">Revealing...</span>
                </>
              ) : (
                <>
                  <span className="cta-sparkle">✨</span>
                  <span className="cta-text">Reveal My Hidden Self</span>
                </>
              )}
            </button>
            <p className="cta-microcopy">2 min. no boring forms.</p>
          </div>

          {/* ── Below-Fold: Glass pill grid ── */}
          <div className="discover-section hero-stagger stagger-5">
            <p className="discover-label-scroll">You'll unlock ↓</p>
            <div className="discover-pill-grid">
              <span className="discover-pill">🧠 Personality</span>
              <span className="discover-pill">🎯 Career Path</span>
              <span className="discover-pill">💡 Study Guide</span>
              <span className="discover-pill">🤝 Your People</span>
            </div>
          </div>



        </div>
      </div>

      <section aria-label="About YDKY" style={{maxWidth: '880px', margin: '24px auto', padding: '24px 24px 120px', color: '#f4ecfa', lineHeight: 1.7}}>
        <h2>Handwriting insights and AI self-reflection</h2>
        <p>{discovery.description}</p>
        <nav aria-label="Public information" style={{display: 'flex', flexWrap: 'wrap', gap: '20px', margin: '20px 0'}}>
          {discovery.pages.map(page => <a key={page.slug} href={`/${page.slug}`} style={{color: '#e4b6ff', textDecoration: 'underline'}}>{page.slug.replace(/-/g, ' ')}</a>)}
        </nav>
        <p>AI interpretations can be wrong. Not a validated psychological assessment.</p>
      </section>
      <Footer />
      </div>

      {/* Mobile Sticky CTA Button */}
      <div className="mobile-sticky-cta mobile-only hero-stagger stagger-4">
        <div className="sticky-gradient-bg"></div>
        <div className="cta-wrapper">
          <div className="cta-glow"></div>
          <button
            className={`glass-cta ${isLoading ? 'loading' : ''}`}
            onClick={handleStartClick}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <div className="button-spinner"></div>
                <span className="cta-text">Revealing...</span>
              </>
            ) : (
              <>
                <span className="cta-sparkle">✨</span>
                <span className="cta-text">Reveal My Hidden Self</span>
              </>
            )}
          </button>
          <p className="cta-microcopy">2 min. no boring forms.</p>
        </div>
      </div>
    </div>
  );
};